<template>
    <v-container>
        <v-card>
            <v-card-title class="justify-center primary" @click="mostrar()" style="cursor: pointer;">
                <v-toolbar-title id="titulocard">Correos</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-icon :color="'#FFFFFF'">{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            </v-card-title>
            <v-expand-transition>
                <div v-if="show">
                    <v-card-text style="margin-bottom: 4%;">
                        <v-row class="mt-1">
                            <v-col cols="12" md="6" sm="6" class="boton_Agregar">
                                <v-btn v-if="adjuntarArchivos == 1" tile @click="AdjuntarCorreo" color="success">
                                    <v-icon left>
                                        mdi-plus
                                    </v-icon>
                                    Agregar Correo
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <DataTable :url="urlListado" :columns="columns" :formatterActions="formatterActions"
                                    :params="displayInputs" :order="[]" @apiDT="apiDT = $event" @Cancelar="CancelarShow">
                                </DataTable>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </div>
            </v-expand-transition>
        </v-card>
    </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Archivos from '@/services/Archivos/Archivos.service.js';
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import DataTable from "@/components/pages/DataTableNet/DataTable";

    export default {
        title() {
            return this.$route.meta.title
        },
    components: {
        DataTable
    },
    data: function () {
        return {
            urlListado: 'Archivos/ObtenerCorreos',
            columns: [
                { name: 'docarchivo', data: 'docarchivo', title: 'Archivo' },
                { name: 'docalta', data: 'docalta', title: 'Fecha' },
                { name: 'prclave', data: 'prclave', title: 'Usuario' },
                { name: "ddocid", data: "docid", title: "", formatter: [this, "Descargar_Archivo"], orderable: false },
                { name: "edocid", data: "docid", title: "", formatter: [this, "Eliminar_Archivo"], orderable: false },
            ],
            show: false,
            displayInputs: {
                nrreporte: 0,
                svindice: 0
            },
            formatterActions: [
                { click: [this, "DescargarArchivo"] },
                { click: [this, "EliminarArchivo"] },
            ],
            apiDT: null,
            adjuntarArchivos: 0,
            verarchi: false,
            permisoEliminar: false,
            datos: null
        }
    },
    props: [],
    computed: {
        ...mapState({ drawer: state => state.drawer }),
        ...mapState(['domain', 'informationPage']),
        DRAWER_STATE: {
            get() {
                return this.drawer
            },
        }
    },
    async mounted() {
        this.datos = await MetodosGenerales.obtenerSessionReporte('reporte');
        await this.obtenerEstadoReporte();
        await this.obtenerPermisos();
        await Archivos.EstatusReporte(this, this.datos);
        this.displayInputs = {
            nrreporte: this.datos.nrreporte,
            svindice: this.datos.svindice,
        };
        this.reloadTable();
    },
    methods: {
        async obtenerPermisos() {
            let response = await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '51');
            if (response.data.length > 0) {
                response.data.forEach(permiso => {
                    if (permiso.peclave == 51)//Permiso Eliminar
                        this.permisoEliminar = true;
                });
            }

        },
        reloadTable() {
            if (this.apiDT != null) {
                this.apiDT.ajax.reload(null, false);
                this.apiDT.columns.adjust().responsive.recalc();
            }
        },
        CancelarShow() {
            this.cargando = false;
        },
        Descargar_Archivo(datos) {
            return datos.docid ? `<div><button type="button" class="mr-1 v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--small info dt-formatterAction" aria-haspopup="true" data-action="0" data-params="${datos.docid}" title="Descargar Archivo" aria-expanded="false"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-download-outline theme--dark"></i></span></button></div>` : ``;
        },
        Eliminar_Archivo(datos) {
            if (this.permisoEliminar) {
                return datos.docid ? `<div><button type="button" class="mr-1 v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--small secondary dt-formatterAction" aria-haspopup="true" data-action="1" data-params="${datos.docid}" title="Eliminar Archivo" aria-expanded="false"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-delete theme--dark"></i></span></button></div>` : ``;
            } else {
                return ``;
            }
        },
        async DescargarArchivo(params, datos, fila) {
            this.$swal({
                title: 'Descargando archivo, espere, por favor.',
                allowEscapeKey: false,
                allowOutsideClick: false,
                didOpen: async () => {
                    this.$swal.showLoading();
                    var datosReporte = new FormData();
                    datosReporte.append("nrreporte", this.datos.nrreporte);
                    datosReporte.append("svindice", this.datos.svindice);
                    let dir = await Archivos.ObtenerDireccion(this.datos, datos.docid, 1);
                    var formData = new FormData();
                    formData.append("lasitio", 'Prusia+');
                    formData.append("lomodulo", datos.Rutaarchivo);
                    formData.append("laaccion", "Descargó Correo");
                    formData.append("lacaracteristicas", this.datos.nrreporte + '-' + this.datos.svindice);
                    formData.append("lanombre", dir.archivo);
                    formData.append("ladestinatario", "");
                    await Archivos.AlmacenarVisitas(formData);
                    if (dir.archivo !== null) {
                        var link = document.createElement('a');
                        document.body.appendChild(link);
                        link.download = dir.archivo;
                        link.href = dir.msg;
                        link.click();
                        document.body.removeChild(link);
                        this.$swal.close();
                    }
                    else {
                        this.$swal({
                            position: 'center',
                            icon: 'warning',
                            title: 'Error',
                            text: dir.msg,
                            showConfirmButton: false,
                            showConfirmButton: true,
                            confirmButtonColor: '#536DFE',
                            confirmButtonText: 'Aceptar',
                            allowOutsideClick: false,
                        });
                        this.verarchi = false;
                    }

                },
            });
        },
        async EliminarArchivo(params, datos, fila) {
            this.$swal({
                position: "center",
                icon: "info",
                text: "¿Está seguro que desea eliminar este archivo?",
                showCancelButton: true,
                confirmButtonColor: '#536DFE',
                cancelButtonColor: '#FF5C93',
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$swal({
                        title: 'Eliminando archivo, espere, por favor.',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: async () => {
                            this.$swal.showLoading();
                            let resp = await Archivos.EliminarArchivo(this.datos, datos.docid);
                            if (resp.error == false) {
                                var datosReporte = new FormData();
                                datosReporte.append("nrreporte", this.datos.nrreporte);
                                datosReporte.append("svindice", this.datos.svindice);
                                var formData = new FormData();
                                formData.append("lasitio", 'Prusia+');
                                formData.append("lomodulo", "Correos");
                                formData.append("laaccion", "Eliminó Correo");
                                formData.append("lacaracteristicas", this.datos.nrreporte + '-' + this.datos.svindice);
                                formData.append("lanombre", datos.docarchivo);
                                formData.append("ladestinatario", "");
                                Archivos.AlmacenarVisitas(formData);
                                this.$swal({
                                    position: 'center',
                                    icon: 'success',
                                    title: 'Éxito',
                                    text: resp.msg,
                                    showConfirmButton: true,
                                    confirmButtonColor: '#536DFE',
                                    confirmButtonText: 'Aceptar',
                                    allowOutsideClick: false,
                                    timer: 2500,
                                }).then(async () => {
                                    this.reloadTable();
                                });

                            } else {
                                this.$swal({
                                    position: 'center',
                                    icon: 'warning',
                                    title: 'Error',
                                    text: resp.msg,
                                    showConfirmButton: true,
                                    confirmButtonColor: '#536DFE',
                                    confirmButtonText: 'Aceptar',
                                    allowOutsideClick: false,
                                });
                            }
                        },
                    });
                }
            });
        },
        async AdjuntarCorreo() {
            let asistenciaurl = await MetodosGenerales.ObtenerURL(this.datos);
            this.$router.push({ path: asistenciaurl + '/Archivos/AdjuntarCorreo' });

        },
        async obtenerEstadoReporte() {
            await Archivos.EstatusReporte(this, this.datos);
        },
        mostrar() {
            if (this.show == true) {
                this.show = false;
                this.correosData = [];
            } else {
                this.show = true;
                this.cargando = true;
            }
        }
    },

}

</script>
<style>
.v-data-table-header {
    font-weight: bold;
    background-color: success;
}

#titulocard {
    color: white;
}
</style>